<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section" v-if="investmentsKoopAccount">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.investments_koop_account.title') }}:
						<span v-if="investmentsKoopAccount.name">{{ investmentsKoopAccount.name }} -</span>
						{{ investmentsKoopAccount.account_id }}
					</h2>
				</header>
				<article>
					<actions-panel>
						<a class="button style-1" @click.prevent="$router.safeBack">
							<span class="inner">{{ $t('general.back') }}</span>
						</a>
					</actions-panel>
					<chart-panels-group :panels-data="panelsData" :charts-data="chartsData" v-if="panelsData.length" :tabs="true"/>
					<p v-else>{{ $t('investments.no_data') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
import investmentsMixin from "@/mixins/investmentsMixin";
import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartPanelsGroup from "@/components/containers/ChartPanelsGroup";
import PanelBoxesContainer from "@/components/containers/PanelBoxesContainer";

export default {
	name: "InvestmentsKoopAccount",
	components: {
		ActionsPanel,
		ChartPanelsGroup,
		PanelBoxesContainer
	},
	mixins: [investmentsMixin],
	computed: {
		investmentsKoopAccount() {
			return this.$store.state.views.investmentsKoopAccount;
		},
		chartsData() {
			return [
				this.balanceChart,
				this.portfoliosChart,
			];
		},
		balanceChart() {
			let data = this.getBalanceChartOptions();
			data.tabName = this.$t('investments.profit');

			let series = [
				{
					name: this.$t('investments.account_balance'),
					data: [],
				},
				{
					name: this.$t('investments.transactions'),
					data: [],
				}
			];

			let currentDate = new Date().toISOString().slice(0, 10);
			(this.investmentsKoopAccount.balances || []).slice().sort((a, b) => {
				return a.date < b.date ? -1 : 1;
			}).forEach(item => {
				series[0].data.push({
					x: item.date.slice(0, 10),
					y: item.amount,
				});
			});
			series[0].data.push({
				x: currentDate,
				y: this.investmentsKoopAccount.balance,
			});

			let balance = 0;
			let contributions = (this.investmentsKoopAccount.contributions || []).slice().sort((a, b) => {
				return a.datum < b.datum ? -1 : 1;
			});
			contributions.forEach(item => {
				balance += parseFloat(item.suma);
				series[1].data.push({
					x: item.datum,
					y: balance.toFixed(2),
				});
			});

			series[1].data.push({
				x: currentDate,
				y: balance.toFixed(2),
			});

			data.series = series;

			data.totalBalance = this.investmentsKoopAccount.balance;
			data.totalDeposits = this.investmentsKoopAccount.deposit;
			data.totalWithdrawals = this.investmentsKoopAccount.withdrawal;
			data.totalFees = this.investmentsKoopAccount.fee;
			data.totalReturn = this.investmentsKoopAccount.return;

			return data;
		},
		portfoliosChart() {
			let data = this.getPortfoliosChartOptions();
			data.tabName = this.$t('investments.allocation');

			let series = [];
			let labels = [];
			(this.investmentsKoopAccount.fondy || []).forEach(item => {
				series.push(parseFloat(item.stavUctu));
				labels.push(item.name || `Fond ${item.fondId}`);
			});

			data.chartOptions.labels = labels;
			data.series = series;

			return data;
		},
		panelsData() {
			let data = [];
			(this.investmentsKoopAccount.fondy || []).forEach(item => {
				data.push({
					id: item.fondId,
					category: this.$t('investments.fund'),
					name: item.name || `Fond ${item.fondId}`,
					description: this.$t('investments.fund_balance'),
					price: parseFloat(item.stavUctu).toFixed(2),
					returnPercentage: false,
					type: 'portfolio',
					portfolioType: 'koop',
					currency: this.getCurrencySymbol(item.mena),
					detail: false,
				});
			});

			return data;
		},
	}
}
</script>

<style scoped>

</style>
